import { render, staticRenderFns } from "./PreviewSMSTemplate.vue?vue&type=template&id=1a837374&scoped=true&"
import script from "./PreviewSMSTemplate.vue?vue&type=script&lang=js&"
export * from "./PreviewSMSTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSMSTemplate.vue?vue&type=style&index=0&id=1a837374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a837374",
  null
  
)

export default component.exports